import React from "react";
import indigoLogo from "assets/img/indigo-logo-purple.png";
import PropTypes from "prop-types";

function MaintenancePage({ window }) {
  const getTimeRemaining = () => {
    if (!window?.scheduledEnd) {
      return null;
    }
    
    const end = new Date(window.scheduledEnd);
    const now = new Date();
    const diff = end - now;
    
    if (diff <= 0) {
      return "Ending soon...";
    }
    
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    
    if (hours > 0) {
      return `Estimated time: ${hours}h ${minutes}m`;
    }
    return `Estimated time: ${minutes} minutes`;
  };

  return (
    <div className="tw-min-h-screen tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-6 tw-relative tw-overflow-hidden">
      {/* Background decorations */}
      <div className="tw-absolute tw-inset-0 tw-overflow-hidden">
        <div className="tw-absolute tw-top-1/4 tw--left-32 tw-w-96 tw-h-96 tw-bg-indigo-50 tw-rounded-full tw-blur-3xl" />
        <div className="tw-absolute tw-bottom-1/4 tw--right-32 tw-w-96 tw-h-96 tw-bg-purple-50 tw-rounded-full tw-blur-3xl" />
        <div
          className="tw-absolute tw-top-1/2 tw-left-1/2 tw--translate-x-1/2 tw--translate-y-1/2 tw-w-[800px] tw-h-[800px] tw-border tw-border-slate-100 tw-rounded-full"
        />
        <div
          className="tw-absolute tw-top-1/2 tw-left-1/2 tw--translate-x-1/2 tw--translate-y-1/2 tw-w-[600px] tw-h-[600px] tw-border tw-border-slate-100 tw-rounded-full"
        />
      </div>

      <div className="tw-relative tw-z-10 tw-text-center tw-max-w-md">
        {/* Logo */}
        <img 
          src={indigoLogo} 
          alt="Indigo EMR" 
          className="tw-h-10 tw-mx-auto tw-mb-12"
        />
        
        {/* Animated icon */}
        <div className="tw-mb-10">
          <div
            className="tw-inline-flex tw-items-center tw-justify-center tw-w-24 tw-h-24 tw-rounded-full tw-bg-indigo-50 tw-text-indigo-600 tw-animate-pulse"
          >
            <svg
              className="tw-w-12 tw-h-12"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
          </div>
        </div>
        
        {/* Content */}
        <h1 className="tw-text-3xl tw-font-bold tw-text-slate-900 tw-mb-4">
          {window?.title || "We'll be right back"}
        </h1>
        
        <p className="tw-text-lg tw-text-slate-500 tw-mb-8 tw-leading-relaxed">
          {window?.message || "Our team is performing scheduled maintenance to bring you an even better experience."}
        </p>
        
        {/* Time badge */}
        {getTimeRemaining() && (
          <div className="tw-inline-flex tw-items-center tw-gap-3 tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-full tw-px-6 tw-py-3">
            <span className="tw-w-2 tw-h-2 tw-bg-green-500 tw-rounded-full tw-animate-pulse" />
            <span className="tw-text-slate-600 tw-font-medium">{getTimeRemaining()}</span>
          </div>
        )}
        
        {/* Footer */}
        <div className="tw-mt-16 tw-text-slate-400 tw-text-sm">
          <p>Questions? Contact applicationsupport@indigoemr.com</p>
        </div>
      </div>
    </div>
  );
}

MaintenancePage.propTypes = {
  window: PropTypes.shape({
    _id: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
    scheduledEnd: PropTypes.string,
  }),
};

export default MaintenancePage;
